"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsBodyInner = exports.TabsBody = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _useStyles = require("../../helpers/useStyles");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".cb9dd0a0e{display:block}.c4a2e4816{padding:2.5rem 1.5625rem 1.875rem}.cb4f1bfd1{padding:2.5rem 0}.c5b5bf9e1{padding:0}");
var styles = {
  root: 'cb9dd0a0e',
  '--view-usual': 'c4a2e4816',
  '--view-child': 'cb4f1bfd1',
  '--view-secondary': 'c5b5bf9e1'
};
/* prevent props errors on init */

var TabsBody = function TabsBody(props) {
  return /*#__PURE__*/_react.default.createElement(TabsBodyInner, props);
};

exports.TabsBody = TabsBody;

var TabsBodyInner = function TabsBodyInner(props) {
  var children = props.children,
      classes = props.classes,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, children);
};

exports.TabsBodyInner = TabsBodyInner;
TabsBodyInner.propTypes = {
  children: _propTypes.node.isRequired,
  classes: (0, _getClassesPropType.getClassesPropType)(styles),
  view: _propTypes.string.isRequired
};
TabsBodyInner.defaultProps = {
  classes: {}
};